import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Merges class names, with later Tailwind utilities winning over earlier ones
 * in the same group. Without the merge step, a caller passing `px-6` to a
 * component whose base is `px-3` would get both and the result would depend on
 * stylesheet order.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
